const Images = {
  downloadButtonApple: require("../assets/images/downloadAppApple.png"),
  downloadButtonGoogle: require("../assets/images/downloadAppGoogle.png"),
  appScreenshots: require("../assets/images/appScreenshots.png"),
  appIcon: require("../assets/images/appIcon.png"),
};

export default Images;
